var React = require('react');

function ConfettiImg5 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.757324 2.47607C20.9094 5.96097 32.4105 20.8433 35.3478 26.9245","stroke":"#FF553C","strokeWidth":"4.87132"}));
}

ConfettiImg5.defaultProps = {"width":"38","height":"28","viewBox":"0 0 38 28","fill":"none"};

module.exports = ConfettiImg5;

ConfettiImg5.default = ConfettiImg5;
